<template>
  <div id="customTestMethodDetailView">
    <div v-if="$route.name === 'my-testmethods'">
      <h1>{{ $t('privatePage.my_testmethods_header') }}</h1>
      <b-col lg="6" style="padding-left: 0px;">
        <b-tabs>
          <b-tab :title="$t('privatePage.standard_testmethods_header')" class="tabContent">
            <div v-if="busyFetching" class="text-center">
              <i class="fa fa-4x fa-spinner fa-pulse"></i>
            </div>
              <test-method-table
              :testMethods="testMethods"
              :currentGroup="currentGroup"
            />
          </b-tab>
          <b-tab :title="$t('privatePage.testbuilder_testmethods_header')" class="tabContent">
            <div v-if="busyFetching" class="text-center">
              <i class="fa fa-4x fa-spinner fa-pulse"></i>
            </div>
            <test-builder-table v-else
              :customTestMethods="customTestMethods"
              @onEditCustomTestMethod="onEditCustomTestMethod"
              @onDeleteCustomTestMethod="onDeleteCustomTestMethod"
            />
            <b-button
              v-if="!busyFetching"
              to="my-testmethods/testbuilder"
              class="btn-secondary mt-2"
            >
              {{$t('privatePage.my_testmethods_add_new')}}
            </b-button>
          </b-tab>
        </b-tabs>
      </b-col>
    </div>
    <div v-else>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import TestBuilderDetailEditor from '../../components/testmethods/testbuilder/testbuilderdetaileditor'
import TestBuilderTable from '../../components/testmethods/testbuilder/testbuildertable'
import TestMethodTable from '../../components/testmethods/standard/testmethodtable'

export default {
  components: {
    TestBuilderDetailEditor,
    TestBuilderTable,
    TestMethodTable
  },
  data() {
    return {
      busyFetching: Boolean,
      customTestMethods: [],
      testMethods: []
    }
  },
  computed: {
    ...mapGetters(['selectedCulture']),
    ...mapGetters('testMethodsModule', [
      'currentTestMethod',
      'currentTestMethodScales',
      'currentNormGroups',
      'questionFormats'
    ]),
    ...mapGetters('userGroupsModule', [
      'currentGroup',
      'availableTestMethods',
      'userCompany'
    ])
  },
  methods: {
    ...mapActions('userGroupsModule', {
      getCustomTestMethods: 'getCustomTestMethods',
      deleteCustomTestMethod: 'deleteCustomTestMethod'
    }),
    ...mapActions('userGroupsModule', {
      selectGroup: 'selectGroup',
      getAvailableTestMethods: 'getAvailableTestMethods'
    }),
    ...mapActions({
      showSuccessMessage: 'showSuccessMessage',
      showErrorMessage: 'showErrorMessage'
    }),
    getAllStandardTestMethods() {
      this.busyFetching = true
      this.getAvailableTestMethods(this.userCompany.id).then(response => {
        this.testMethods = response.length ? response : []
        this.busyFetching = false
      })
    },
    getAllCustomTestMethods() {
      this.busyFetching = true
      this.getCustomTestMethods().then(response => {
        this.customTestMethods = response.length ? response : []
        this.busyFetching = false
      })
    },
    onEditCustomTestMethod(selectedTestMethod) {
      this.$router.push({
        name: 'testbuilder',
        params: {
          selectedTestMethod
        }
      })
    },
    onDeleteCustomTestMethod(selectedTestMethod) {
      if (
        window.confirm(
          this.$t('privatePage.testmethodDelete_confirmation')
        )
      ) {
        this.deleteCustomTestMethod({
          testMethod: selectedTestMethod
        }).then(() => {
          this.getAllCustomTestMethods()
          this.showSuccessMessage(
            this.$t('privatePage.testmethodDelete_message')
          )
        })
      }
    }
  },
  created() {
    this.getAllCustomTestMethods()
    this.selectGroup()
    this.getAllStandardTestMethods()
  }
}
</script>

<style>
.tabContent {
  margin-top: 30px;
}
</style>
